import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '../../services/wealthlane-award-services';

const useGetTransactionIntendedShareRegistrationsOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: number | string;
    }>
  | undefined,
  unknown
> => {
  const transactionIntendedShareRegistrationsOptions = useQuery(
    ['getTransactionIntendedShareRegistrationsOptions'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesIntendedShareRegistrations()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionIntendedShareRegistrationsOptions;
};

export default useGetTransactionIntendedShareRegistrationsOptions;
